"use client";

import { createPopoverStore } from "./3UYWTADI.js";
import { createStore } from "./EQQLU3CG.js";
import { defaultValue } from "./PBFD2E7P.js";
import { __spreadProps, __spreadValues } from "./3YLGPPWQ.js";

// src/hovercard/hovercard-store.ts
function createHovercardStore() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _a;
  var syncState = (_a = props.store) == null ? void 0 : _a.getState();
  var popover = createPopoverStore(__spreadProps(__spreadValues({}, props), {
    placement: defaultValue(props.placement, syncState == null ? void 0 : syncState.placement, "bottom")
  }));
  var timeout = defaultValue(props.timeout, syncState == null ? void 0 : syncState.timeout, 500);
  var initialState = __spreadProps(__spreadValues({}, popover.getState()), {
    timeout: timeout,
    showTimeout: defaultValue(props.showTimeout, syncState == null ? void 0 : syncState.showTimeout),
    hideTimeout: defaultValue(props.hideTimeout, syncState == null ? void 0 : syncState.hideTimeout),
    autoFocusOnShow: defaultValue(syncState == null ? void 0 : syncState.autoFocusOnShow, false)
  });
  var hovercard = createStore(initialState, popover, props.store);
  return __spreadProps(__spreadValues(__spreadValues({}, popover), hovercard), {
    setAutoFocusOnShow: function setAutoFocusOnShow(value) {
      return hovercard.setState("autoFocusOnShow", value);
    }
  });
}
export { createHovercardStore };